// extracted by mini-css-extract-plugin
export default {"title":"release_title__kqjaY","img":"release_img__8LjNC"};